// src/pages/ConfirmEmail.jsx
// Opened from "Confirm this email" in the secondary email message
// (…/portal/?confirm-email=<token>). The link works once, for 24 hours.
import { useEffect, useState } from 'react';
import { confirmSecondaryEmail } from '../utils/api';
import { pathForTab, DEFAULT_TAB } from '../utils/tabRoutes';
import AuthShell, { AuthMessage } from '../components/AuthShell';
import { S } from './ChooseOwnPassword';

export function confirmEmailTokenFromLocation() {
  return new URLSearchParams(window.location.search).get('confirm-email');
}

export default function ConfirmEmail({ token }) {
  const [state, setState] = useState('checking');   // 'checking' | 'done' | 'problem'
  const [result, setResult] = useState({});
  useEffect(() => {
    confirmSecondaryEmail(token)
      .then(r => { setResult(r); setState(r.confirmed ? 'done' : 'problem'); })
      .catch(e => { setResult({ message: e.message }); setState('problem'); });
  }, [token]);
  const goToPortal = () => window.location.assign(pathForTab(DEFAULT_TAB));

  return (
    <AuthShell stack>
      <h1 style={S.title}>Secondary email</h1>
      {state === 'checking' && <p style={S.text}>Confirming your email…</p>}
      {state === 'done' && (
        <>
          <AuthMessage tone="success">
            <strong>{result.email}</strong> is confirmed. You can now sign in with it and your usual password, and faxes you send by email from it count as yours.
          </AuthMessage>
          <button onClick={goToPortal} className="auth-btn">Go to the Fax Portal</button>
        </>
      )}
      {state === 'problem' && (
        <>
          <AuthMessage tone="error">{result.message || 'This link is not valid.'}</AuthMessage>
          <button onClick={goToPortal} className="auth-btn">Go to the Fax Portal</button>
        </>
      )}
    </AuthShell>
  );
}
